import BlockIntroView from "../snippet/BlockIntroView";
import React from "react";
import {IContentBlock} from "../../../ts/data/subject/PostDataHelper";

const CustomLayoutView = (block: IContentBlock) =>
{
    return <>
        {!!block.anchor && <>
            <div id={block.anchor}></div>
        </>}
        <div className="container">
            <BlockIntroView {...block}/>
            {block.children}
        </div>
    </>
}
export default CustomLayoutView;